import React, { useEffect } from 'react'

export default function RedirectHomePage ({ ...props })
{
	useEffect(function ()
	{	
		window.location.pathname = '/';
	},
	[]);

	return null;
}